import React from "react";
import { QuickStatusDot } from "./QuickStatusDot.jsx";

/**
 * Single row inside ModuleCard per module-card-row-contract.
 * @param {object} props
 * @param {object} props.row
 * @param {(row: object) => void} [props.onRowClick]
 */
export function ModuleCardRow({ row, onRowClick }) {
  const clickable = Boolean(row.clickTarget || onRowClick);
  const Tag = clickable ? "button" : "div";

  const handleClick = () => {
    if (onRowClick) onRowClick(row);
  };

  return (
    <Tag
      type={clickable ? "button" : undefined}
      className={`cq-module-card__row${clickable ? " cq-module-card__row--clickable" : ""}`}
      data-row-id={row.rowId}
      aria-label={row.accessibilityLabel || row.title}
      onClick={clickable ? handleClick : undefined}
    >
      {row.statusDot ? (
        <QuickStatusDot
          statusTone={row.statusDot.tone || "neutral"}
          statusKey={row.statusDot.canonKey || row.rowId}
          label={row.statusDot.badge || row.title}
          accessibleLabel={row.accessibilityLabel || row.title}
          size={row.statusDot.size || "sm"}
          testId={row.statusDot.testId || "quick-status-dot"}
        />
      ) : (
        <span aria-hidden="true" />
      )}
      <div className="cq-module-card__row-text">
        <div className="cq-module-card__row-title">{row.title}</div>
        {row.subtitle ? <div className="cq-module-card__row-subtitle">{row.subtitle}</div> : null}
        {row.meta ? <div className="cq-module-card__row-meta">{row.meta}</div> : null}
      </div>
      {row.actionLabel ? <span className="cq-module-card__row-action">{row.actionLabel}</span> : null}
    </Tag>
  );
}
